<script setup lang="ts">
import { onLaunch } from "@dcloudio/uni-app";
import config, { Patform } from "./config";
import { onErrorCaptured, onMounted } from "vue";
import { AxiosError } from "axios";
import { BusinessErrors, NologinEror } from "@/lib/axios";
import "./app.scss";
import { useLoginStore } from "./stores/login";
import { useStore } from "./stores";
import {useRefreshWxOpenid} from "./hooks/useRefreshWxOpenid";
import useIsBlack from "./hooks/useIsBlack";

const loginstore = useLoginStore();
loginstore.testLogin();

declare var VConsole: any;

function errHander(err: any) {
  const returnRes = true; //true会继续甩出，控制台能看到更多报错，false阻止向上传递
  if (typeof err == "string") {
    uni.showToast({ icon: "none", title: err });
    console.error(err);
    return false;
  }

  if (err instanceof NologinEror) {
    uni.showToast({ icon: "none", title: "请先登录" });
    uni.reLaunch({ url: "/pages/login/login?nav=" + err.curPage });
    return returnRes;
  }

  if (err instanceof BusinessErrors) {
    const errstr =
      err.info +
      " " +
      (err.data
        ? typeof err.data == "string"
          ? err.data
          : JSON.stringify(err.data)
        : "");
    uni.showToast({ icon: "none", title: errstr });

    return returnRes;
  }

  if (err instanceof AxiosError) {
    const res = err.response;
    if (res) {
      if (res.data) {
        if (res.data.error) {
          if (
            err!.response!.data.error.code == "100" ||
            err!.response!.data.error.code == "101"
          ) {
            localStorage.setItem("autogo", "shop");
            uni.navigateTo({ url: "/pages/login/login" });
            return returnRes;
          }
          const errstr = res.data.error.info + " " + res.data.data;
          uni.showToast({ icon: "none", title: errstr });
          return returnRes;
        }
      }
    }

    console.error("未处理的网络错误", err);

    return returnRes;
  }

  console.log(err);
  return returnRes; //true会继续甩出，控制台能看到更多报错，false阻止向上传递
}

window.onerror = errHander;
window.addEventListener("unhandledrejection", (e) => {
  errHander(e.reason);
});

onLaunch(async () => {
  console.log("App Launch");
  document.body.removeChild(document.querySelector("#loadingbox")!);
  const href = window.location.href;
  if (
    href.includes("192") ||
    href.includes("172") ||
    href.includes("local") ||
    href.includes("/gxftest")
  ) {
    const el = document.createElement("script") as HTMLScriptElement;
    el.onload = function () {
      console.log("平台", config.env);
      if (config.env == Patform.h5) {
        return;
      }
      new VConsole();
    };
    el.src = "./static/vconsole.js";
    document.body.appendChild(el);
    console.log("本地开发模式（vconsole）");
  }

  // 监听所有路由跳转
  const methods = ['navigateTo', 'redirectTo', 'reLaunch', 'switchTab']
  
  methods.forEach(method => {
    uni.addInterceptor(method, {
      invoke(args) {
        useIsBlack(args.url);
        return args
      }
    })
  })

  useRefreshWxOpenid();

  // 刷新页面时设置主题颜色
  const usestroe = useStore();
  usestroe.initShopInfo();
});

onErrorCaptured(errHander);

onMounted(() => {

  window.addEventListener('popstate', (e) => {
    setTimeout(() => {
      const pages = getCurrentPages()
      const currentPage = pages[pages.length - 1];
      if (currentPage && currentPage.route) {
        useIsBlack(currentPage.route);
      }
    }, 100)
  })

  setTimeout(() => {
    useIsBlack();
  }, 100)
})
</script>
<style>
body {
  font-size: 26rpx;
  line-height: 1;
}

uni-page-head {
  user-select: none;
}
</style>
